import React, { Component } from "react"
import { TextField } from "@material-ui/core"
import { CardElement } from "@stripe/react-stripe-js"

class CardForm extends Component {
  state = {
    coupon: "",
  }

  componentDidMount() {
    this.props.onRef(this)
  }
  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  render() {
    return (
      <div>
        <CardElement />
        <TextField
          style={{ marginTop: "10px" }}
          value={this.state.coupon}
          label="Coupon Code"
          onChange={e => this.setState({ coupon: e.target.value })}
          fullWidth
        />
      </div>
    )
  }
}

export default CardForm
